var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value !== null)?_c('div',{staticClass:"vote-display"},[_c('b-icon',{staticClass:"has-text-warning star-outline",attrs:{"icon":"star","size":"is-small"}}),_c('span',{staticClass:"vote-text"},[_vm._v(_vm._s(_vm.value.toFixed(1))+"/10")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }